import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

// Configure global axios base URL from environment
const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production'
  ? 'https://extensync.onrender.com/api'
  : 'http://localhost:5000/api');

axios.defaults.baseURL = API_BASE_URL;

// Rewrite accidental localhost absolute URLs to the configured API base
axios.interceptors.request.use((config) => {
  try {
    const url = config.url || '';
    if (url.startsWith('http://localhost:5000')) {
      // Preserve path after host and map to API base host
      const path = url.replace('http://localhost:5000', '');
      // Ensure single slash between base and path
      config.url = `${API_BASE_URL.replace(/\/$/, '')}${path}`;
    }
  } catch (_) {}
  return config;
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
